"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = {
  strokeClassName: _propTypes.default.string,
  fillClassName: _propTypes.default.string,
  evenClassName: _propTypes.default.string,
  colorLabelClassName: _propTypes.default.string,
  transparentClassName: _propTypes.default.string,
  thinClassName: _propTypes.default.string,
  strokeMitterClassName: _propTypes.default.string,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  colorStyle: _propTypes.default.object
};
exports.default = _default;